import React, { FC } from 'react';
import { Column, Columns, Container } from '../../components/base/grid';
import { H1 } from '../../components/base/typography';
import Breadcrumbs from '../../components/breadcrumbs';
import SendReceiptMultistepComponent from '../../components/sendReceiptMultistep';
import pageWrapper from '../../hoc/pageWrapper';
import IPageViewModel from '../../interfaces/umbracoNodes/pageViewModel';

interface Props {
	page: IPageViewModel;
}

const SendReceiptMultistep: FC<Props> = ({ page }) => {
	return (
		<Container>
			<Breadcrumbs pageId={page.Id} />
			<H1 marginTop="4rem" marginBottom="4rem">
				{page.Name}
			</H1>
			<Columns>
				<Column desktopSmall={2 / 3}>
					<SendReceiptMultistepComponent />
				</Column>
			</Columns>
		</Container>
	);
};

export default pageWrapper(SendReceiptMultistep);
